import { render, staticRenderFns } from "./holidayActFemaleRules.vue?vue&type=template&id=2945371e&scoped=true"
import script from "./holidayActFemaleRules.vue?vue&type=script&lang=js"
export * from "./holidayActFemaleRules.vue?vue&type=script&lang=js"
import style0 from "./holidayActFemaleRules.vue?vue&type=style&index=0&id=2945371e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2945371e",
  null
  
)

export default component.exports